// extracted by mini-css-extract-plugin
export default {"wrap":"AboutScreen_wrap__tPYsQ","head_wrapper":"AboutScreen_head_wrapper__C0ZvZ","decor":"AboutScreen_decor__6xxtN"};